// src/config.js
const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:9090",
  SOCKET_BASE_URL:
    process.env.REACT_APP_SOCKET_BASE_URL || "http://localhost:9090",
};

export default config;
